export const radii = {
	none: '0px',
	xs: '2px',
	sm: '4px',
	md: '6px',
	lg: '8px',
};
